import { render } from "./Menu.vue?vue&type=template&id=1e7f8f00&ts=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Nodejs\\MaysTekpanel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__